import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 409 `catalog_stale_write` (AUT-437): someone saved the row while it was
 * open. Not dismissable — it stays until the next successful save. The
 * fresh row is already loaded; the typed values are kept in the form.
 */
export const StaleBanner = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <Alert severity="warning" role="alert">
      <AlertTitle>{t('vehicleCatalog.stale.title')}</AlertTitle>
      {t('vehicleCatalog.stale.body')}
    </Alert>
  );
};
